module.exports = __webpack_public_path__ + "img/icon-plus.8fb82b8b.svg";